import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry } from '@cian/mf-registry/browser';
import { getTelemetry } from '@cian/telemetry/browser';
import { IApplicationContext, IApplicationContextCustom } from 'shared/types/applicationContext';
import { getEventQueue } from 'shared/utils/eventQueue';

import { createMicrofrontendsAPI } from '../microfrontends';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
    custom: config.get<IApplicationContextCustom>('applicationContext.custom') || {},
    microfrontendsRegistry: registry(),
    microfrontendsAPI: createMicrofrontendsAPI(),
    eventQueue: getEventQueue(),
  };
};
